export class PersistenceError extends Error {
    kind;
    cause;
    constructor(kind, message, cause) {
        super(message);
        this.kind = kind;
        this.cause = cause;
        this.name = 'PersistenceError';
    }
}
//# sourceMappingURL=errors.js.map